"use client";

import { BreadcrumbItem, Breadcrumbs } from "@/components/breadcrumbs";
import { useStore } from "@/contexts/store";
import { productAnalitica } from "@/app/(store)/_utils/events";
import { useProductStore } from "@/stores";

type Props = {
  loading?: boolean;
};

export const ProductBreadcrumbs = ({ loading, ...rest }: Props) => {
  const { product } = useProductStore();
  const { store } = useStore();

  const breadcrumbs: BreadcrumbItem[] = [
    { label: "Início", href: `/${store.identifier}` },
  ];

  if (product.category?.name) {
    breadcrumbs.push({
      label: product.category.name,
      href: `/${store.identifier}?categoria=${product.category.id}`,
    });
  }

  breadcrumbs.push({
    label: product.name,
  });

  return (
    <div className="align-center flex justify-center">
      <Breadcrumbs
        items={breadcrumbs}
        loading={loading}
        onLinkClick={() => productAnalitica.events.action.breadcrumbClicked()}
        {...rest}
      />
    </div>
  );
};
